import type { RawLocation } from 'vue-router';
import type { AssessmentMode } from '../types/assessment-mode.types';

const ASSESSMENT_MODE_ROUTE_NAMES: Record<AssessmentMode, string> = {
  text: 'AssessmentModeText',
  guided: 'AssessmentModeGuided',
  voice: 'AssessmentModeVoice',
};

/*  The picker is mounted twice: at the entry point and at the mode route. Both mean the
    worker is choosing a mode, so neither may inherit a session left behind by the last one. */
export const ASSESSMENT_MODE_PICKER_ROUTE_NAMES = ['AssessmentModeSelection', 'Assessment Entry'] as const;
export const ASSESSMENT_MODE_PICKER_ROUTE_PATHS = ['/assessment_mode', '/assessment_entry'] as const;

export const ASSESSMENT_MODE_ROUTE_LOCATIONS: Record<AssessmentMode, RawLocation> = {
  text: {
    name: ASSESSMENT_MODE_ROUTE_NAMES.text,
  },
  guided: {
    name: ASSESSMENT_MODE_ROUTE_NAMES.guided,
  },
  voice: {
    name: ASSESSMENT_MODE_ROUTE_NAMES.voice,
  },
};


